$(document).ready(function () {
  // Open dropdown menu and change button when clicked
  $(".dropdown__button").on("click", function (event) {
    event.preventDefault();

    $(".dropdown__button").toggleClass("clicked");
    $(".dropdown__menu").toggleClass("opened");
  });

  // Close dropdown menu and restore button when scrolling
  $(window).on("scroll", function () {
    if ($(".dropdown__menu").hasClass("opened")) {
      $(".dropdown__button").removeClass("clicked");
      $(".dropdown__menu").removeClass("opened");
    }
  });

  // Close dropdown menu and restore button when clicking outside the menu
  document.addEventListener("click", function (e) {
    const dropdown = document.querySelector(".dropdown__container");

    if (e.target !== dropdown && !dropdown.contains(e.target)) {
      if ($(".dropdown__menu").hasClass("opened")) {
        $(".dropdown__button").removeClass("clicked");
        $(".dropdown__menu").removeClass("opened");
      }
    }
  });
});
